var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3333 30.3632C63.6667 30.0298 58.7498 29.8639 53.6248 29.8223H47.3748C42.3331 29.8639 37.0833 30.0715 31.6667 30.3632H31.5833C14.7917 31.9048 9.375 39.5298 9.375 61.6132C9.375 93.2798 21.25 93.2798 50 93.2798C78.75 93.2798 90.625 93.2798 90.625 61.6132C90.625 39.5298 85.2083 31.9048 68.3333 30.3632Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1246 17.3713L59.9538 24.2171C60.5621 24.8296 61.3663 25.1379 62.1663 25.1379C62.9621 25.1379 63.7621 24.8296 64.3704 24.2254C65.5954 23.0046 65.5954 21.0254 64.3788 19.8046L52.2121 7.60459C51.0413 6.42542 48.9579 6.42542 47.7871 7.60459L35.6204 19.8046C34.4038 21.0254 34.4038 23.0046 35.6288 24.2254C36.8538 25.4421 38.8288 25.4421 40.0454 24.2171L46.8746 17.3713V60.0248C46.8746 61.7402 48.3143 63.1176 50.0296 63.1176C51.7459 63.1175 53.1246 61.7386 53.1246 60.0224V17.3713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.7be68ea0292d29f47a82c2f06c246de5.svg";
export { ForwardRef as ReactComponent };